import "phaser";

class CursorHandler {
    private game: Phaser.Game;
    public defaultCursor = "default";
    private clickables: Phaser.InputHandler[];

    constructor(game: Phaser.Game) {
        this.game = game;
        this.game.state.onCreateCallback = () => {
            this.defaultCursor = "default";
            this.clickables = [];
        };
        this.game.state.onCreateCallback();
    }

    addClickable(c: Phaser.InputHandler) {
        this.clickables.push(c);
    }

    update() {
        let isOver = false;
        for (let clickable of this.clickables) {
            if (clickable.pointerOver(this.game.input.activePointer.id)) {
                this.game.canvas.style.cursor = "pointer";
                isOver = true;
                break;
            }
        }
        if (!isOver) {
            this.game.canvas.style.cursor = this.defaultCursor;
        }
    }
}

let _instance: CursorHandler | null = null;

export function initialize(game: Phaser.Game) {
    _instance = new CursorHandler(game);
}

export function instance(): CursorHandler {
    if (!_instance) throw "CursorHandler not initialized!";
    return _instance;
}



// WEBPACK FOOTER //
// ./src/cursor.ts